import { createRoot } from "react-dom/client";
import { HelmetProvider } from 'react-helmet-async';
import App from "./App.tsx";
import "./i18n";
import "./index.css";

// Fonts loaded asynchronously after critical CSS
// This prevents render-blocking while ensuring fonts are available
import '@fontsource/noto-kufi-arabic/400.css';
import '@fontsource/noto-kufi-arabic/700.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/700.css';
// v2 marketing display fonts — IBM Plex Sans Arabic + Space Grotesk (max weight 700 available)
import '@fontsource/ibm-plex-sans-arabic/400.css';
import '@fontsource/ibm-plex-sans-arabic/700.css';
import '@fontsource/space-grotesk/500.css';
import '@fontsource/space-grotesk/700.css';
// English font — Inter (loaded for both languages; active font swapped via body class)
import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

createRoot(document.getElementById("root")!).render(
    <HelmetProvider>
        <App />
    </HelmetProvider>
);
